import { Fragment, useEffect, useRef } from "react";
import styled from "styled-components";
// import $ from 'jquery';
// import DateBox from "devextreme/ui/date_box";
import moment from "moment-timezone";

import { Button } from "devextreme-react";
import DataGrid, {
    Column,
    FilterRow,
    Scrolling,
    Selection,
    StateStoring,
} from "devextreme-react/data-grid";

import axios from "axios";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { RadioGroup } from "devextreme-react/radio-group";
import { useState } from "react";
import { API_URL } from "../../ConstVariable";
import "../../dx-styles.scss";
import styles from "./PatientList.module.css";
import { useSelector } from "react-redux";
import AudioPlayerWidget from "../../Components/ConversationWidget/AudioPLayerWidget";
import { useAuth0 } from "@auth0/auth0-react";
import Input from "../../UI/Input";

const FinalSelect = styled.div`
  margin-top: 10px;
  /* text-align: center; */
  display: flex;
  justify-content: center;
  font-size: 16px;
  align-items: center;
  width: 100%;
`;

const ConfirmationDiv = styled.div`
  margin-top: 15px;
  /* text-align: center; */
  display: flex;
  justify-content: center;
  font-size: 16px;
  align-items: center;
  width: 100%;
`;
const ConfirmationButton = styled.button`
  padding: 10px;
  border: none;
  background: #499f4c;
  color: white;
  width: 15%;
`;

const PatientSearchBar = styled.div`
  display: flex;
  align-items: center;
  ${"" /* justify-content: space-between; */}
  width: 100%;
  margin-bottom: 10px;
`;

const ErroContainer = styled.p`
  position: absolute;
  top: -30px;
  right: 0;
  color: red;
  fontsize: 20px !important;
  fontweight: bold;
  background: yellow;
  padding-left: 10px;
  padding-right: 10px;
`;
const InfoText = styled.p`
  display: flex;
  justify-content: center;
  color: black;
  background:yellow ;
  width:70%;
  margin:auto ;
  margin-bottom:5px ;
  margin-top:5px ;
  padding:2px ;
  font-size:17px ;
`;
const NoteText = styled.p`
  display: flex;
  color: black;
  margin-bottom:5px ;
  margin-top:5px ;
  padding:2px ;
  font-size:17px ;
  font-family:italic ;
`;
const DataGridNoteText = styled.p`
  display: flex;
  color: black;
  margin-bottom:5px ;
  margin-top:5px ;
  padding:2px ;
  font-size:17px ;
  font-family:italic ;
  color:#184063
`;
const NotCreateUserText = styled.p`
display: grid;
justify-content: center;
text-align:center ;
color: black;
background:yellow ;
width:60%;
margin:auto ;
margin-bottom:5px ;
margin-top:5px ;
padding:2px ;
font-size:17px ;
`;

const capitalize = (str) => {
    if (str) {
        const lower = str.toLowerCase();
        return str.charAt(0).toUpperCase() + lower.slice(1);
    } else {
        return ""
    }
};

const AiCapturedDetails = (props) => {
    const { user } = useAuth0();
    const state = useSelector((state) => state);
    let selectedConversationId = state.SelectedConversationId;
    let src;
    if (
        selectedConversationId != null && ["MOBILE", "LANDLINE", "PRIVATE", "PBX"].includes(state.CallSource)
    ) {
        src = `${API_URL}/oi/api/twilio/audio/${selectedConversationId}`;
    }

    const [orderData, setOrderData] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        mobileNo: "",
        insuraceType: "",
        insuranceNumber: "",
    });

    useEffect(() => {
        if (props?.orderObj) {
            setOrderData({
                firstName: capitalize(props?.orderObj.first_name),
                lastName: capitalize(props.orderObj.last_name),
                dob: props.orderObj.DOB,
                mobileNo: props.orderObj.contact,
                insuraceType: props.gpOrderDetails.insuranceType,
                insuranceNumber: props.gpOrderDetails.insuranceNumber
                    ? props.gpOrderDetails.insuranceNumber
                    : "",
            });
        }
    }, [props.popupVisible]);

    const PatientDetailsInGpWorkFlow = ({ orderData }) => {
        return (
            <Fragment>
                <span style={{ marginLeft: "5px", fontSize: "19px" }}> </span>{" "}
                <span style={{ fontSize: "18px" }}>
                    <span style={{ marginRight: "10px" }}>{orderData.firstName}</span>{" "}
                    <span style={{ marginRight: "15px" }}>{orderData.lastName}, </span>{" "}
                    <span style={{ marginRight: "15px" }}> {orderData.dob}, </span>{" "}
                    {/* <span style={{ marginRight: "15px" }}>{orderData.mobileNo}, </span>{" "} */}
                    <span style={{ marginRight: "15px" }}>{orderData?.mobileNo == null ? 'NA' : (orderData?.mobileNo?.trim()?.includes('+61') ? orderData?.mobileNo?.trim()?.substring(0, 3) + ' ' + orderData?.mobileNo?.trim()?.substring(3, 6) + ' ' + orderData?.mobileNo?.trim()?.substring(6, 9) + ' ' + orderData?.mobileNo?.trim()?.substring(9, 14) : (orderData?.mobileNo?.trim()?.startsWith('0') ? orderData?.mobileNo?.trim()?.substring(1, 4) + ' ' + orderData?.mobileNo?.trim()?.substring(4, 7) + ' ' + orderData?.mobileNo?.trim()?.substring(7, 12) : orderData?.mobileNo?.trim()?.length == 9 ? orderData?.mobileNo?.trim()?.substring(0, 3) + ' ' + orderData?.mobileNo?.trim()?.substring(3, 6) + ' ' + orderData?.mobileNo?.trim()?.substring(6, 9) + ' ' + orderData?.mobileNo?.trim()?.substring(9, 14) : orderData?.mobileNo?.trim()))} </span>{" "}

                    <span>
                        {orderData.insuraceType}{" "}
                        <span style={{ marginLeft: "3px", marginRight: "3px" }}> /</span>{" "}
                    </span>{" "}
                    <span> {orderData.insuranceNumber} </span>{" "}
                </span>{" "}
            </Fragment>
        );
    };

    const PatientDetailsInImgWorkFlow = ({ orderData }) => {
        const [isContactBoxDisabled,setIsContactBoxDisabled]=useState(true)
        const [updatedPatientsDetails,setUpdatedPatientsDetails]=useState(orderData)
        const [errorNote,setErrorNote]=useState("")

        const isValidDateFormat = (dateString) => {
            // Regular expression to match dd/mm/yyyy format
            const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
            return regex.test(dateString);
          };

        return (
            <Fragment>
                <span style={{ marginLeft: "5px", fontSize: "19px" }}> </span>{" "}
                <span style={{ fontSize: "18px" }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <div>
                            <label htmlFor="firstNameInput" style={{ display: 'block', marginBottom: '5px' }}>
                                First Name
                            </label>
                            <input 
                                id="firstNameInput"
                                className={isContactBoxDisabled ? styles.disabledInput : ''}
                                style={{borderRadius:"3px",width:"140px",marginRight: "10px" }}
                                disabled={isContactBoxDisabled}
                                defaultValue={updatedPatientsDetails?.firstName}
                                onChange={(e)=>{setUpdatedPatientsDetails({...updatedPatientsDetails,firstName:e.target.value})}}
                            />
                        </div>
                        <div>
                            <label htmlFor="lastNameInput" style={{ display: 'block', marginBottom: '5px' }}>
                                Last Name
                            </label>
                            <input 
                                id="lastNameInput"
                                className={isContactBoxDisabled ? styles.disabledInput : ''}
                                style={{borderRadius:"3px",width:"140px",marginRight: "10px" }}
                                disabled={isContactBoxDisabled}
                                defaultValue={updatedPatientsDetails?.lastName}
                                onChange={(e)=>{setUpdatedPatientsDetails({...updatedPatientsDetails,lastName:e.target.value})}}
                            />
                        </div>
                        <div>
                            <label htmlFor="dobInput" style={{ display: 'block', marginBottom: '5px' }}>
                                Date of Birth
                            </label>
                            <input
                                id="dobInput"
                                className={isContactBoxDisabled ? styles.disabledInput : ''}
                                style={{borderRadius:"3px",width:"120px",marginRight: "10px" }}
                                disabled={isContactBoxDisabled}
                                placeholder="DD/MM/YYYY"
                                //    mask="00/00/0000" 
                                defaultValue={updatedPatientsDetails.dob}
                                onChange={(e) => {setUpdatedPatientsDetails({ ...updatedPatientsDetails, dob: e.target.value })}}
                            />
                        </div>
                        <div>
                            <label htmlFor="contactNoInput" style={{ display: 'block', marginBottom: '5px' }}>
                                Mobile No.
                            </label>
                            <input
                                id="contactNoInput"
                                className={isContactBoxDisabled ? styles.disabledInput : ''}
                                style={{borderRadius:"3px",width:"170px"}}
                                disabled={isContactBoxDisabled}
                                defaultValue={orderData?.mobileNo == null ? 'NA' : (orderData?.mobileNo?.trim()?.includes('+61') ? orderData?.mobileNo?.trim()?.substring(0, 3) + ' ' + orderData?.mobileNo?.trim()?.substring(3, 6) + ' ' + orderData?.mobileNo?.trim()?.substring(6, 9) + ' ' + orderData?.mobileNo?.trim()?.substring(9, 14) : (orderData?.mobileNo?.trim()?.startsWith('0') ? orderData?.mobileNo?.trim()?.substring(1, 4) + ' ' + orderData?.mobileNo?.trim()?.substring(4, 7) + ' ' + orderData?.mobileNo?.trim()?.substring(7, 12) : orderData?.mobileNo?.trim()?.length == 9 ? orderData?.mobileNo?.trim()?.substring(0, 3) + ' ' + orderData?.mobileNo?.trim()?.substring(3, 6) + ' ' + orderData?.mobileNo?.trim()?.substring(6, 9) + ' ' + orderData?.mobileNo?.trim()?.substring(9, 14) : orderData?.mobileNo?.trim()))}
                                onChange={(e)=>{setUpdatedPatientsDetails({...updatedPatientsDetails,mobileNo:e.target.value})}}
                            />
                        </div>
                        <Button
                            type="default"
                            rtlEnabled={true}
                            icon={isContactBoxDisabled?"Edit":"Save"}
                            style={{ marginLeft: "10px",marginTop:"18px",height:"30px",border:"0px",borderRadius:"5px" }}
                            onClick={(e)=>{
                                console.log('updatedPatientsDetails?.dob = ', updatedPatientsDetails?.dob)
                                if (!updatedPatientsDetails?.dob) {
                                    setErrorNote("Date of birth cannot be empty. Please specify the date of birth.")
                                    return ;
                                }
                                else if (!isValidDateFormat(updatedPatientsDetails?.dob )){
                                    setErrorNote("Date of birth is incorrect. It should be in DD/MM/YYYY format.")
                                    return ;
                                } else {
                                    const dobDate = moment(updatedPatientsDetails?.dob, 'DD/MM/YYYY', true);
                                    if (dobDate.isAfter(moment(), 'day')) {
                                        setErrorNote('Date should not be in the future.');
                                        return;
                                        }
                                        setIsContactBoxDisabled(!isContactBoxDisabled)
                                        if(!isContactBoxDisabled){
                                            setOrderData({...orderData,mobileNo:updatedPatientsDetails?.mobileNo,firstName:updatedPatientsDetails?.firstName,lastName:updatedPatientsDetails?.lastName,dob:updatedPatientsDetails?.dob})
                                            props.SetOrderObj({...props.orderObj,contact:updatedPatientsDetails?.mobileNo,first_name:updatedPatientsDetails?.firstName,last_name:updatedPatientsDetails?.lastName,DOB:updatedPatientsDetails?.dob})
                                        }
                                        setErrorNote("")
                                    }
                                }}
                            ></Button>
                        {!isContactBoxDisabled &&  <Button
                                type="default"
                                rtlEnabled={true}
                                icon={"revert"}
                                style={{ marginLeft: "10px",marginTop:"18px",height:"30px",border:"0px",borderRadius:"5px" }}
                                onClick={(e)=>{
                                    setIsContactBoxDisabled(!isContactBoxDisabled)
                                    if(!isContactBoxDisabled){
                                        setOrderData({...orderData,mobileNo:orderData.mobileNo,firstName:orderData?.firstName,lastName:orderData?.lastName,dob:orderData?.dob})
                                        props.SetOrderObj({...props.orderObj,contact:orderData.mobileNo,first_name:orderData?.firstName,last_name:orderData?.lastName,DOB:orderData?.dob})
                                    }
                                    setErrorNote("")
                                }}
                            ></Button>
                        } 
                        <span style={{color:"red", fontSize:"14px" ,marginLeft:"10px", marginTop:"18px", alignSelf:"center"}}>{errorNote}</span>
                    </div>
                </span>{" "}
            </Fragment>
        );
    };

    return (
        <Fragment>


            <div
                style={{
                    position: "relative",
                    paddingBottom: "5px",
                    // marginBottom: "50px",
                    marginTop: "25px",
                    borderBottom: "1px solid lightgrey",
                }}
            >
                <div
                    style={{
                        width: "fitContent",
                        borderBottom: "2px solid black",
                        fontSize: "18px",
                        position: "absolute",
                        top: "-35px",
                        fontWeight: "500",
                        marginBottom: "10px",
                    }}
                >
                    {" "}
                    Details captured by AI{" "}
                </div>

                {props.gotAnyErrorDuringPatientSearch && (
                    <ErroContainer style={{ fontSize: "18px" }}>
                        {props.gotAnyErrorDuringPatientSearch.error_code} -{" "}
                        {props.gotAnyErrorDuringPatientSearch.error_description}{" "}
                    </ErroContainer>
                )}
                <div
                    style={{
                        padding: "20px 10px",
                        background: "lightyellow",
                        fontWeight: "500",
                    }}
                >
                    <div>
                        {props.conversationWorkflow === "GP_WORKFLOW" ? (
                            <PatientDetailsInGpWorkFlow orderData={orderData} />
                        ) : (
                            <PatientDetailsInImgWorkFlow orderData={orderData} />
                        )}

                    </div>


                </div>


            </div>
            <div style={{ display: 'flex', justifyContent: 'right' }}>{user?.oi_profile?.toLowerCase() !== "customer" && <AudioPlayerWidget src={src} />} </div>

        </Fragment>
    );
};


const PatientSearch = ({
    setSearchedPatientData,
    center_id,
    dob,
    popupVisible,
    orderObj,
    setDataGridDetailsStatus,
    setIsSearchBeing,
    isSearchBeing,
    setGotAnyErrorDuringPatientSearch,
    conversationWorkflow,
}) => {
    const [searchParams, setSearchParams] = useState({
        center_id: "",
        search_by: "DOB",
        search_value: "",
    });
    const [formDetails, setFormDetails] = useState({
        DOB: "",
        FNAME: "",
        LNAME: "",
    });

    useEffect(() => {
        if (popupVisible) {
            setFormDetails({
                DOB: orderObj?.DOB,
                FNAME: "",
                LNAME: "",
            });
        }
        return () => {
            setFormDetails({
                DOB: "",
                FNAME: "",
                LNAME: "",
            });
        };
    }, [popupVisible]);
    useEffect(()=>{
        setFormDetails({
            DOB: orderObj?.DOB,
            FNAME: "",
            LNAME: "",
        });
        let date_of_birth=orderObj?.DOB
        console.log("date_of_birth",date_of_birth)
        if(date_of_birth && date_of_birth!=""){
             searchHandler(date_of_birth)
        }
    },[orderObj?.DOB,orderObj?.first_name])

    const formRef = useRef();

    const [isFetchingData, setIsfetchingData] = useState(false);

    useEffect(() => {
        if (center_id) {
            setSearchParams({
                ...searchParams,
                center_id: center_id,
            });
            // if(dob){
            //   var date = moment(dob, 'DD/MM/YYYY')
            //   console.log("Date of Birth",dob,new Date(date),moment(date).format('YYYY-MM-DD'))
            //   setSearchParams({
            //     ...searchParams,
            //     search_value:moment(date).format('YYYY-MM-DD'),

            // })
            // }
        }
    }, [center_id]);

    //On page load , searching the patient details
    useEffect(() => {
        if (formDetails.DOB && popupVisible) {
            searchHandler();
        }
    }, [formDetails.DOB, popupVisible]);

    const searchHandler = (date_of_birth) => {
        setDataGridDetailsStatus("BEING_SEARCH");
        setGotAnyErrorDuringPatientSearch(null);

        var formData = new FormData();
        let res = formRef.current.instance.option("formData");

        // if (!res.DOB) return;

        setSearchedPatientData([]);
        let DateOfBirth = "";

        if (res.DOB.includes("/")) {
            let [day, month, year] = date_of_birth ? date_of_birth.split("/"): res.DOB.split("/");

            DateOfBirth = `${year}-${month}-${day}`;
        } else {
            if (res.DOB.length < 8) {
                DateOfBirth = "";
            } else {
                let day = res.DOB.substring(0, 2);
                let month = res.DOB.substring(2, 4);
                let year = res.DOB.substring(4);
                DateOfBirth = `${year}-${month}-${day}`;
            }
        }

        setIsfetchingData(true);
        let url = `${API_URL}/oi/api/v2/search-pms-v2`;
        let method = "POST";

        let requestData = {};
        if (conversationWorkflow === "GP_WORKFLOW") {
            requestData["center_id"] = searchParams.center_id;
            requestData["dob"] = DateOfBirth;
            requestData["first_name"] = res.FNAME;
            requestData["last_name"] = res.LNAME;
        } else {
            // requestData["center_id"]=searchParams.center_id
            method = "GET";
            requestData = null;

            url = `${API_URL}/oi/api/v2/get-comrad-patients?center_id=${searchParams.center_id}&dob=${DateOfBirth}`;
        }

        let token = localStorage.getItem("MyToken");
        if(!searchParams.center_id || !DateOfBirth){
            setIsfetchingData(false);
            setIsSearchBeing(false);
            return ;
        }
        setIsSearchBeing(true);

        axios({
            method: method,
            url: url,
            data: requestData,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        })
            .then((response) => {
                if (response.data.error_code === 0 || response.data.error_code === 404) {
                    if (response.data.result.length === 0) {
                        setDataGridDetailsStatus("NO_DATA");
                    } else {
                        const sortedPatientList = [...response.data.result].sort((a, b) => a.FIRSTNAME.localeCompare(b.FIRSTNAME));
                        
                        setSearchedPatientData(sortedPatientList);
                        setDataGridDetailsStatus(null);
                    }
                    setGotAnyErrorDuringPatientSearch(null);
                } else {
                    setDataGridDetailsStatus(null);
                    setGotAnyErrorDuringPatientSearch({
                        error_code: response.data.error_code,
                        error_description: response.data.error_description,
                    });
                }
                setIsfetchingData(false);
                setIsSearchBeing(false);
            })
            .catch((error) => {
                setDataGridDetailsStatus(null);
                let errorMessage = ''
                if (error.message.includes('401')) {
                    setGotAnyErrorDuringPatientSearch({
                        error_code: "401",
                        error_description: 'Authentication Token Expired. Please refresh page and try again.',
                    });
                } else if (error.message.includes('403')) {
                    setGotAnyErrorDuringPatientSearch({
                        error_code: "403",
                        error_description: 'Authentication Token Expired. Please refresh page and try again.',
                    });
                } else {
                    setGotAnyErrorDuringPatientSearch({
                        error_code: "E101",
                        error_description: error.message,
                    });

                }


                setIsfetchingData(false);
                setIsSearchBeing(false);

                console.log(error);
            });
    };

    return (
        <Fragment>
            <div style={{ position: "relative", margin: "50px 0px 0px 0px" }}>
                <div
                    style={{
                        width: "fitContent",
                        borderBottom: "2px solid black",
                        position: "absolute",
                        zIndex: "100",
                        top: "-60px",
                        fontSize: "18px",
                        fontWeight: "500",
                    }}
                >
                    {" "}
                    Search{" "}
                </div>
                <PatientSearchBar>
                    <Form formData={formDetails} ref={formRef} labelMode="static">
                        {conversationWorkflow === "GP_WORKFLOW" ? (
                            <GroupItem colCount={3}>
                                <SimpleItem
                                    dataField="DOB"
                                    editorOptions={{
                                        placeholder: "DD/MM/YYYY",
                                        mask: "00/00/0000",
                                    }}
                                    label={{ text: "DOB(dd/mm/yyyy)", location: "top" }}
                                //  caption={"DOB(DD/MM/YYYY)"}
                                />

                                <SimpleItem
                                    dataField="FNAME"
                                    label={{ text: "First name", location: "top" }}
                                />
                                <SimpleItem
                                    dataField="LNAME"
                                    label={{ text: "Surname", location: "top" }}
                                />
                            </GroupItem>
                        ) : (
                            <GroupItem>
                                <SimpleItem
                                    dataField="DOB"
                                    editorOptions={{
                                        placeholder: "DD/MM/YYYY",
                                        mask: "00/00/0000",
                                    }}
                                    label={{ text: "DOB(dd/mm/yyyy)", location: "top" }}
                                //  caption={"DOB(DD/MM/YYYY)"}
                                />
                            </GroupItem>
                        )}
                    </Form>
                    <div>
                        {isSearchBeing ? (
                            <Button
                                text="...Searching"
                                type="default"
                                rtlEnabled={true}
                                // icon="search"
                                style={{ marginLeft: "10px" }}
                            // onClick={searchHandler}
                            ></Button>
                        ) : (
                            <Button
                                text="Search"
                                type="default"
                                rtlEnabled={true}
                                icon="search"
                                style={{ marginLeft: "10px" }}
                                onClick={searchHandler}
                            ></Button>
                        )}
                    </div>
                </PatientSearchBar>
                {/*  */}
            </div>
        </Fragment>
    );
};

const PatientDataGrid = ({
    searchedPatientData,
    setOrderObj,
    setGpOrderDetails,
    setPopupVisible,
    sendGpOrderDetails,
    gpOrderDetails,
    popupVisible,
    appointment_to_be_booked_manually,
    dataGridDetailsStatus,
    isSearchBeing,
    bp_appointment_id,
    orderObj: demographicDetails,
    gotAnyErrorDuringPatientSearch,
    conversationWorkflow,
    sendAppointmentDataFunc
}) => {
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const dataGridRef = useRef();
    const [isConfirmButtonClicked,setIsConfirmButtonClicked]=useState(false);
    useEffect(() => {
        //   console.log("dataGridRef",dataGridRef)
        dataGridRef?.current?.instance.clearFilter();

        return () => {
            setSelectedRowData(null);
            setSelectedOption(null);
        };
    }, [popupVisible]);
    useEffect(() => {
        if (isSearchBeing) {
            setSelectedRowData(null);
            setSelectedOption(null);
        }
    }, [isSearchBeing]);

    const selectHandler = () => {
        // if (!selectedRowData) return;

        let data1 = {
            first_name: selectedRowData.FIRSTNAME.trim(),
            last_name: selectedRowData.SURNAME.trim(),
            DOB: moment(selectedRowData.DOB).format("DD/MM/YYYY"),
        };

        if (conversationWorkflow === "IMAGING_WORKFLOW") {
            data1["pms_patient_guidance_id"] = selectedRowData?.INTERNALID;

            setOrderObj(data1);
        }
        if (conversationWorkflow === "GP_WORKFLOW") {
            let data2 = {
                insuranceNumber: selectedRowData?.MEDICARENO,
                pms_patient_guidance_id: selectedRowData?.INTERNALID,
                pms_mobile: selectedRowData.MOBILEPHONE,
                pms_landline: selectedRowData.HOMEPHONE
            };
            // return
            setOrderObj(data1);
            setGpOrderDetails(data2);
        }

        setPopupVisible();
    };

    useEffect(() => {
        if (
            conversationWorkflow === "IMAGING_WORKFLOW" &&
            demographicDetails.pms_patient_guidance_id != null
        ) {
            sendAppointmentDataFunc();
        }
        if (
            conversationWorkflow === "GP_WORKFLOW" &&
            gpOrderDetails.pms_patient_guidance_id != null
        ) {
            sendGpOrderDetails();
        }
    }, [gpOrderDetails.pms_patient_guidance_id]);

    // Patient confirmation handler

    const confirmHandler = () => {
        if (gotAnyErrorDuringPatientSearch) return;
        
        setIsConfirmButtonClicked(true)

        if (selectedOption === "Yes") {
            if(demographicDetails?.consider_contact_no_for_patient_matching && selectedRowData && selectedRowData?.HOMEPHONE_E164_FORMAT != demographicDetails.contact && selectedRowData?.MOBILEPHONE_E164_FORMAT != demographicDetails.contact){
    
            }else if(ShowMobileNumberNotMatchingMsg()) {
           
            }else{
                selectHandler();
            }
            
        } else {
            if(checkIsPatientsPresentInDatagrid()){

            }else{
                let data = {
                    pms_patient_guidance_id: -1,
                };
    
                if (conversationWorkflow === "IMAGING_WORKFLOW") {
                    setOrderObj(data);
                }
                if (conversationWorkflow === "GP_WORKFLOW") {
                    setGpOrderDetails(data);
                }
    
                setPopupVisible();
            }
        }
    };
 
    const dataItems1 = [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" },
    ];

    const dataItems2 = [
        { text: "Yes", value: "Yes", disabled: true },
        { text: "No", value: "No" },
    ];
    const onCellRender = (data, demographicDetails) => {
        return <div style={{ background: "green" }}>{data?.text}</div>;
    };
    // const onCellPrepared = (e) => {

    //     if (e.row?.isSelected) {
    //         console.log(e.row)
    //         try {
    //             if (e.column.name === "FIRSTNAME" && e.value != selectedRowData.first_name) {

    //                 e.cellElement.addClass('invalid');
    //             }
    //             if (e.column.name === "FIRSTNAME" && e.value === selectedRowData.first_name) {
    //                 e.cellElement.addClass('valid');
    //             }
    //         } catch (e) {
    //             console.error(e);
    //         }
    //         console.log(e)
    //     }
    // }

    const renderTitleHeader = (data) => {
        return <p style={{ fontWeight: "bold" }}>{data.column.caption}</p>;
    };

    // const [focusedRowKey, setFocusedRowKey] = useState(null);


    // useEffect(() => {
    // if(demographicDetails?.first_name!=null)
    // {
    //   setFocusedRowKey(demographicDetails?.first_name?.toUpperCase());
    // }

    // }, [searchedPatientData]);


    // const handleFocusedRowChanged = (e) => {
    //   setFocusedRowKey(e.row?.key);
    // };

    const onRowPrepared = (e) => {
        if (e.rowType == 'data') {
            if (demographicDetails?.first_name != null) {
                if (e?.data?.FIRSTNAME?.toLowerCase() === demographicDetails?.first_name.toLowerCase()) {
                    e.rowElement.style.backgroundColor = 'rgba(40, 98, 147, 0.8)'
                    e.rowElement.style.color = '#fff'

                }
            }

        }
    }

    const ShowMobileNumberNotMatchingMsg=()=>{
        return selectedRowData?.HOMEPHONE_E164_FORMAT != demographicDetails.contact && selectedRowData?.MOBILEPHONE_E164_FORMAT != demographicDetails.contact && demographicDetails?.consider_contact_no_for_patient_matching 
    }
    const checkIsPatientsPresentInDatagrid=()=>{
        let isPresent= false ;
        searchedPatientData?.forEach(patient_obj => {
            if(patient_obj.FIRSTNAME.toLowerCase()==demographicDetails?.first_name.toLowerCase() && patient_obj.SURNAME.toLowerCase()==demographicDetails?.last_name.toLowerCase() &&
           ( demographicDetails?.contact==patient_obj?.MOBILEPHONE_E164_FORMAT ||  demographicDetails?.contact==patient_obj?.HOMEPHONE_E164_FORMAT)
            ){
                isPresent=true
            }
        });
      return isPresent ;
    }

    return (
        <Fragment>
            <div style={{overflow:"auto",height:"500px"}}>
              {searchedPatientData?.length!=0  && <div><DataGridNoteText>Showing patients with matching firstname, lastname and date of birth only.</DataGridNoteText></div>}
              {searchedPatientData?.length==0 && !isSearchBeing &&  <div><NoteText>No records found for matching firstname, lastname and date of birth.</NoteText></div>}
         {searchedPatientData.length!=0 && 
              <DataGrid
              id="dataGrid"
              ref={dataGridRef}
              dataSource={searchedPatientData}
              // keyExpr="FIRSTNAME"
              onRowPrepared={onRowPrepared}

              showBorders={true}
              // focusedRowEnabled={true}
              // focusedRowKey={focusedRowKey}
              // onFocusedRowChanged={handleFocusedRowChanged}
              // autoNavigateToFocusedRow={true}

              // keyExpr="INTERNALID"
              height={"330px"}
              noDataText={
                dataGridDetailsStatus === "BEING_SEARCH"
                    ? "Search in progress..."
                    : dataGridDetailsStatus === "NO_DATA"
                        ? "No record found"
                        : "Search the patient details"
            }
  
              showColumnLines={true}
              showRowLines={true}
              onSelectionChanged={(e) => {
                  e.component.selectRows(e.currentSelectedRowKeys[0], false);

                  if (e.currentSelectedRowKeys[0]) {
                  }
                  setSelectedRowData(e.selectedRowsData[0]);
                  setSelectedOption(null);
              }}
              onCellPrepared={(e) => {

                  if (e.rowType === "header") {
                      e.cellElement.classList.add("headers");
                      e.cellElement.style.backgroundColor = "#ADDEE6";
                  }
                  if (e.rowType === "data") {
                      if (e.row?.isSelected) {
                          let column = e.column.dataField;

                          if (
                              column === "FIRSTNAME" &&
                              e?.text?.trim().toLowerCase() ===
                              demographicDetails?.first_name?.trim().toLowerCase()
                          )
                              e.cellElement.style.backgroundColor = "lightgreen";
                          if (
                              column === "FIRSTNAME" &&
                              e?.text?.trim().toLowerCase() !=
                              demographicDetails?.first_name?.trim().toLowerCase()
                          )
                             { 
                            e.cellElement.style.backgroundColor = "red";
                             e.cellElement.style.color = "white";
                          }


                          if (
                              column === "SURNAME" &&
                              e?.text.trim().toLowerCase() ===
                              demographicDetails?.last_name?.trim().toLowerCase()
                          )
                              e.cellElement.style.backgroundColor = "lightgreen";
                          if (
                              column === "SURNAME" &&
                              e?.text?.trim().toLowerCase() !=
                              demographicDetails?.last_name?.trim().toLowerCase()
                          )
                             { e.cellElement.style.backgroundColor = "red";
                              e.cellElement.style.color = "white";}
                          if (
                              column === "DOB" &&
                              e?.text?.trim().toLowerCase() ===
                              demographicDetails?.DOB?.trim().toLowerCase()
                          )
                              e.cellElement.style.backgroundColor = "lightgreen";
                          if (
                              column === "DOB" &&
                              e?.text?.trim().toLowerCase() !=
                              demographicDetails?.DOB?.trim().toLowerCase()
                          )
                             {
                              e.cellElement.style.backgroundColor = "red";
                              e.cellElement.style.color = "white"
                             }



                          if (column == "MOBILEPHONE") {
                              let phone_1 = e?.text?.trim().toLowerCase();
                              let phone_2 =  demographicDetails?.contact?.trim().toLowerCase();

                              phone_1 = phone_1.replace(/\s+/g, "");
                              phone_2 = phone_2.replace(/\s+/g, "");

                              phone_1 = phone_1.split("").reverse().join("");
                              phone_2 = phone_2.split("").reverse().join("");

                              phone_1 = phone_1.substring(0, 9);
                              phone_2 = phone_2.substring(0, 9);
                            
                              if (demographicDetails?.contact==e?.data?.MOBILEPHONE_E164_FORMAT) {
                                  e.cellElement.style.backgroundColor = "lightgreen";
                              }else if(demographicDetails?.contact==e?.data?.HOMEPHONE_E164_FORMAT){
                                
                              } else {
                                if( e?.data?.MOBILEPHONE_E164_FORMAT==null && e?.data?.HOMEPHONE_E164_FORMAT!=null ){

                                }else{
                                    e.cellElement.style.backgroundColor = "red";
                                    e.cellElement.style.color = "white";
                                }
                              }
                          }

                          if (column == "HOMEPHONE") {
                              let phone_1 = e?.text?.trim().toLowerCase();
                              let phone_2 =  demographicDetails?.contact?.trim().toLowerCase();

                              phone_1 = phone_1.replace(/\s+/g, "");
                              phone_2 = phone_2.replace(/\s+/g, "");

                              phone_1 = phone_1.split("").reverse().join("");
                              phone_2 = phone_2.split("").reverse().join("");

                              phone_1 = phone_1.substring(0, 9);
                              phone_2 = phone_2.substring(0, 9);

                              if (demographicDetails?.contact==e?.data?.HOMEPHONE_E164_FORMAT && demographicDetails?.contact!=null) {
                                  e.cellElement.style.backgroundColor = "lightgreen";
                              }else if(demographicDetails?.contact==e?.data?.MOBILEPHONE_E164_FORMAT){
                                
                              }else {
                                if( e?.data?.MOBILEPHONE_E164_FORMAT!=null && e?.data?.HOMEPHONE_E164_FORMAT==null ){

                                }else{
                                e.cellElement.style.backgroundColor = "red";
                                e.cellElement.style.color = "white";
                                }
                             
                            }

                          }


                          if (
                              gpOrderDetails.insuranceType !== "CASH" &&
                              column === "MEDICARENO" &&
                              e?.text?.trim() &&
                              gpOrderDetails?.insuranceNumber?.trim() &&
                              e?.text?.trim() === gpOrderDetails?.insuranceNumber?.trim()
                          )
                              e.cellElement.style.backgroundColor = "lightgreen";
                          if (
                              gpOrderDetails.insuranceType !== "CASH" &&
                              column === "MEDICARENO" &&
                              e?.text?.trim() &&
                              gpOrderDetails?.insuranceNumber?.trim() &&
                              e?.text?.trim() != gpOrderDetails?.insuranceNumber?.trim()
                          )
                              e.cellElement.style.backgroundColor = "red";
                      }
                  }
              }}
          >
              <Selection
                  mode="multiple"
                  showCheckBoxesMode="always"
                  allowSelectAll={false}
              ></Selection>
              <FilterRow visible={true} applyFilter="auto"  />

              <StateStoring
                  enabled={false}
                  type="localStorage"
                  storageKey="storage"
              />
              {conversationWorkflow === "IMAGING_WORKFLOW" && (
                  <Column
                      dataField="INTERNALID"
                      caption={"DB ID"}
                      allowFiltering={true}
                      headerCellRender={renderTitleHeader}
                      width={"100px"}
                  />
              )}

              <Column
                  dataField="FIRSTNAME"
                  defaultFilterValue={demographicDetails?.first_name ? demographicDetails.first_name : null}
                  caption={"First Name"}
                  calculateCellValue={(rowData) => {
                      return rowData["FIRSTNAME"];
                  }}
                  headerCellRender={renderTitleHeader}
                  alignment="left"
              />
              <Column
                  dataField="SURNAME"
                  caption={"Surname"}
                  headerCellRender={renderTitleHeader}
                  // alignment="right"
                  editorOptions={{
                      placeholder: "Filter by surname",
                  }}
              />
              <Column
                  dataField="DOB"
                  caption={"Date of birth"}
                  dataType="date"
                  format={"dd/MM/yyyy"}
                  allowFiltering={false}
                  headerCellRender={renderTitleHeader}
                  width={"130px"}
              // alignment="right"
              //     editorOptions={{
              //   placeholder: 'DD/MM/YYYY'
              // }}
              />
              {conversationWorkflow === "IMAGING_WORKFLOW" && (
                  <Column
                      dataField="GENDER"
                      caption={"Gender"}
                      dataType="date"
                      format={"dd/MM/yyyy"}
                      allowFiltering={false}
                      headerCellRender={renderTitleHeader}
                      width={"80px"}
                  // alignment="right"
                  //     editorOptions={{
                  //   placeholder: 'DD/MM/YYYY'
                  // }}
                  />
              )}
              <Column
                  dataField="MOBILEPHONE"
                  caption={"Mobile"}
                  headerCellRender={renderTitleHeader}
                  // alignment="right"
                  editorOptions={{
                      placeholder: "Filter by mobile no.",
                  }}
              />
              <Column
                  dataField="HOMEPHONE"
                  caption={"Home Phone"}
                  allowFiltering={false}
                  headerCellRender={renderTitleHeader}
              // alignment="right"
              />
               {conversationWorkflow === "IMAGING_WORKFLOW" && (
                  <Column
                      dataField="URN"
                      caption={"URN"}
                      allowFiltering={false}
                      headerCellRender={renderTitleHeader}
                      width={"120px"}
                  />
              )}
              {conversationWorkflow === "GP_WORKFLOW" && (
                  <Column
                      dataField="MEDICARENO"
                      caption={"Medicare"}
                      calculateCellValue={(rowData) => {
                          if (rowData.MEDICARENO != null && rowData.MEDICARELINENO == null)
                              return rowData.MEDICARENO;
                          if (rowData.MEDICARENO != null && rowData.MEDICARELINENO != null)
                              return rowData.MEDICARENO + "-" + rowData.MEDICARELINENO;
                          return "";
                      }}
                      headerCellRender={renderTitleHeader}
                      // alignment="right"
                      editorOptions={{
                          placeholder: "Filter by medicare no",
                      }}
                  />
              )}
              {conversationWorkflow === "GP_WORKFLOW" && (
                  <Column
                      dataField="ADDRESS1"
                      caption={"Address"}
                      calculateCellValue={(rowData) => {
                          let address = "";
                          if (rowData.ADDRESS1) {
                              address = rowData.ADDRESS1;
                          }
                          if (rowData.ADDRESS2) {
                              address = `${address} ${rowData.ADDRESS2}`;
                          }
                          if (rowData.POSTCODE) {
                              address = `${address} ${rowData.POSTCODE}`;
                          }
                          return address;
                      }}
                      allowFiltering={false}
                      headerCellRender={renderTitleHeader}
                  // alignment="right"
                  ></Column>
              )}

              <Scrolling mode="infinite" />
          </DataGrid>} 
      
            { !isSearchBeing && !bp_appointment_id ? (
                <Fragment>
                    <FinalSelect>
                        <div className="" style={{ marginRight: "15px", fontSize: "17px" }}>
                            Did you find the matching patient ?.
                        </div>
                        <form className={styles.radio_button}>
                            <RadioGroup
                                dataSource={
                                    Array.isArray(searchedPatientData) &&
                                        searchedPatientData.length !== 0
                                        ? dataItems1
                                        : dataItems2
                                }
                                layout="horizontal"
                                value={selectedOption}
                                displayExpr="text"
                                valueExpr="value"
                                onValueChanged={(e) => {
                                    setSelectedOption(e.value);
                                    setIsConfirmButtonClicked(false)
                                }}
                                style={{ fontSize: "19px" }}
                            // disabled={!selectedRowData}
                            />
                        </form>
                    </FinalSelect>
                </Fragment>
            ) : (
                ""
            )}
            {!isSearchBeing && !bp_appointment_id && (
                <Fragment>
                     {searchedPatientData?.length > 0 &&
                        selectedOption === "Yes" &&
                        !selectedRowData && (
                            <InfoText>
                                Please select the patient to confirm the booking
                            </InfoText>
                        )}
                        { checkIsPatientsPresentInDatagrid() &&
                        selectedOption === "No"  && isConfirmButtonClicked
                        && (
                            <NotCreateUserText>
                               <div> Cannot create a new record. An existing record with all the matching details already present.</div>
                                <div>Please select the record and Save.</div> 
                            </NotCreateUserText>
                        )}
                         <div> {selectedRowData && selectedOption=="Yes" ?
                         (ShowMobileNumberNotMatchingMsg() && isConfirmButtonClicked  ?<InfoText>Cannot proceed as the contact numbers are not matching. Please select any other record OR save it as a new patient.</InfoText>:""):""}</div>
                    <ConfirmationDiv>
                        {" "}
                        <ConfirmationButton
                           disabled={
                            gotAnyErrorDuringPatientSearch
                                ? true
                                : !selectedOption
                                    ? true
                                    : searchedPatientData?.length > 0 &&
                                        selectedOption === "Yes" &&
                                        !selectedRowData
                                        ? true
                                        : gotAnyErrorDuringPatientSearch && selectedOption === "No"
                                            ? true
                                            : false
                        }
                        style={{
                            background:ShowMobileNumberNotMatchingMsg() && selectedRowData && selectedOption=="Yes" && isConfirmButtonClicked?"lightgrey" :gotAnyErrorDuringPatientSearch
                                ? "lightgrey"
                                : !selectedOption
                                    ? "lightgrey"
                                    : searchedPatientData?.length > 0 &&
                                        selectedOption === "Yes" &&
                                        !selectedRowData
                                        ? "lightgrey"
                                        : gotAnyErrorDuringPatientSearch && selectedOption === "No"
                                            ? "lightgrey"
                                            : "#499f4c",
                        }}
                            onClick={confirmHandler}
                        > 
                            Confirm
                        </ConfirmationButton>{" "}
                    </ConfirmationDiv>
                </Fragment>
            )}

            {/* <Button text="Confirm" type="" style={{width:"100%"}}></Button> */}
            </div>
        </Fragment>
    );
};

const PatientList = (props) => {
    const [searchedPatientData, setSearchedPatientData] = useState([]);
    const [dataGridDetailsStatus, setDataGridDetailsStatus] = useState(null);
    const [isSearchBeing, setIsSearchBeing] = useState(false);
    const [gotAnyErrorDuringPatientSearch, setGotAnyErrorDuringPatientSearch] =
        useState(null);
    const [orderObj,SetOrderObj]=useState(props.orderObj)

    useEffect(() => {
        return () => {
            setSearchedPatientData([]);
            setDataGridDetailsStatus(null);
        };
    }, [props.popupVisible]);
    return (
        <Fragment>
            {/* Shows the patient order details cpatured by AI */}
            <AiCapturedDetails
                orderObj={orderObj}
                gpOrderDetails={props.gpOrderDetails}
                popupVisible={props.popupVisible}
                gotAnyErrorDuringPatientSearch={gotAnyErrorDuringPatientSearch}
                conversationWorkflow={props.conversationWorkflow}
                SetOrderObj={(data)=>{SetOrderObj(data)}}
            />
            {/* Using this component to search the patient details */}
            <PatientSearch
                setSearchedPatientData={(val) => setSearchedPatientData(val)}
                center_id={props.centerId}
                dob={props.dob}
                popupVisible={props.popupVisible}
                orderObj={orderObj}
                setDataGridDetailsStatus={(val) => setDataGridDetailsStatus(val)}
                setIsSearchBeing={(val) => setIsSearchBeing(val)}
                isSearchBeing={isSearchBeing}
                setGotAnyErrorDuringPatientSearch={(val) =>
                    setGotAnyErrorDuringPatientSearch(val)
                }
                conversationWorkflow={props.conversationWorkflow}
            />
            <hr></hr>

            {/* This component  shows the patient details in the datagrid  and confirm the order  */}
            <PatientDataGrid
                setPopupVisible={props.setPopupVisible}
                searchedPatientData={searchedPatientData}
                orderObj={orderObj}
                gpOrderDetails={props.gpOrderDetails}
                setOrderObj={props.setOrderObj}
                setGpOrderDetails={props.setGpOrderDetails}
                sendGpOrderDetails={props.sendGpOrderDetails}
                popupVisible={props.popupVisible}
                appointment_to_be_booked_manually={
                    props.appointment_to_be_booked_manually
                }
                dataGridDetailsStatus={dataGridDetailsStatus}
                isSearchBeing={isSearchBeing}
                bp_appointment_id={props.bp_appointment_id}
                gotAnyErrorDuringPatientSearch={gotAnyErrorDuringPatientSearch}
                conversationWorkflow={props.conversationWorkflow}
                sendAppointmentDataFunc={props.sendAppointmentDataFunc}
            />
        </Fragment>
    );
};

export default PatientList;
